<template>
  <div class="filter-container" :class="{ open: visible }">
    <div class="field-container">
      <DropList :label="labels.filters.function" :data="functions" v-model="selectedFunction"
        :placeholder="labels.filters.selectFunction" @change="onFunctionChanged"></DropList>
    </div>
    <div class="field-container">
      <CheckboxGroup :label="labels.filters.ecolabel">
        <Checkbox v-for="(e, index) in ecolabels" :label="e.name" :value="e.id" :checked="false" :key="e.id" v-model="checkboxValues[index]"
          @change="onEcolabelsChanged" :ref="e.id" :tooltip="tooltips[e.id]" ></Checkbox>
      </CheckboxGroup>
    </div>

    <div class="field-container">
      <Slider ref="rciSlider" :label="labels.filters.rci" :min="minRci" :max="maxRci"
        v-model="rci" :value="rci" @change="onRCIChanged" :tooltip="tooltips['8a5e8571ec5743a0b737581c35c95328']" :interval="1">
      </Slider>
    </div>

    <div class="field-container">
      <Slider ref="ewgSlider" :label="labels.filters.ewg" :min="minEwg" :max="maxEwg"
        v-model="ewg" :value="ewg" @change="onEWGChanged" :tooltip="tooltips['77b72aa9b2d44469ba80dc9781b95327']" :interval="1">
      </Slider>
    </div>
    <div class="field-container button-container">
      <FlatButton blue :label="labels.filters.showResults" @click="showResults()" class="hide-on-desktop"></FlatButton>
      <FlatButton white :label="labels.filters.clear" @click="clearFilters()"></FlatButton>
    </div>
    <!--<div class="field-container top-margin">
      <div class="small">* {{labels.filters.rciExplanation}}</div>
      <div class="small">** {{labels.filters.ewgExplanation}}</div>
    </div>-->
  </div>
</template>

<script>
import { DropList, CheckboxGroup, Checkbox, FlatButton } from "clariant-vue3-forms";
import Slider from "./Slider.vue";
import Labels from "../services/labels";
import State from "../services/state";
import Utils from "../services/utils";

export default {
  name: "Filters",
  props: ["visible"],
  components: {
    DropList,
    CheckboxGroup,
    Checkbox,
    Slider,
    FlatButton
  },
  data() {
    return {
      labels: Labels,
      state: State,
      functions: [],
      ecolabels: [],
      rci: [0, 100],
      ewg: [0, 10],
      filters: State.filters,
      selectedFunction: "",
      isDirty: false,
      tooltips: {},
      checkboxValues: [],
      minRci: 0,
      maxRci: 100,
      minEwg: 0,
      maxEwg: 10
    };
  },
  created() {
    Utils.initArray(this.checkboxValues, new Array(50).fill(false));
  },
  mounted() {
    State.subscribe("filters-updated", this.initFilters);
    State.subscribe("labels-updated", this.initLabels);
    this.initFilters(State.filters);
  },
  unmounted() {
    State.unsubscribe("labels-updated", this.initLabels);
    State.unsubscribe("filters-updated", this.initFilters);
  },
  methods: {
    initFilters(val) {
      Utils.initArray(this.functions, val.functions);
      Utils.initArray(this.ecolabels, val.ecolabels);
      this.rci[0] = val.rciRange[0];
      this.rci[1] = val.rciRange[1];
      this.ewg[0] = val.ewgRange[0];
      this.ewg[1] = val.ewgRange[1];
      this.minRci = val.rciRange[0];
      this.maxRci = val.rciRange[1];
      this.minEwg = val.ewgRange[0];
      this.maxEwg = val.ewgRange[1];
    },
    initLabels(val) {
      console.log("Filters received ecolabel information.");
      if (val && val.length > 0) {
        val.map(el => {
          this.tooltips[el.id] = el.description;
        });
      }
    },
    onFunctionChanged() {
      State.filterValues.function = this.selectedFunction;
      this.isDirty = true;
      this.$emit("change", State.filterValues);
    },
    onEcolabelsChanged(e) {
      if (!e.sender) return;
      let nPos = State.filterValues.ecolabels.indexOf(e.sender.value);
      if (e.checked && nPos === -1) {
        this.isDirty = true;
        State.filterValues.ecolabels.push(e.sender.value);
      }
      else if (!e.checked && nPos !== - 1) {
        this.isDirty = true;
        State.filterValues.ecolabels.splice(nPos, 1);
      }
      this.$emit("change", State.filterValues);

      const index = this.ecolabels.findIndex(x => x.id === e.sender.value);
      if (index != -1) this.checkboxValues[index] = e.checked;

    },
    onRCIChanged() {
      State.filterValues.rci = this.rci;
      this.isDirty = true;
      this.$emit("change", State.filterValues);
    },
    onEWGChanged() {
      State.filterValues.ewg = this.ewg;
      this.isDirty = true;
      this.$emit("change", State.filterValues);
    },
    showResults() {
      this.$emit("toggle");
    },
    clearFilters() {
      /* Clear state */
      if (!this.isDirty) return;
      State.filterValues.function = "";
      State.filterValues.ecolabels = [];
      State.filterValues.rci[0] = State.filters.rciRange[0];
      State.filterValues.rci[1] = State.filters.rciRange[1];
      State.filterValues.ewg[0] = State.filters.ewgRange[0];
      State.filterValues.ewg[1] = State.filters.ewgRange[1];

      /* clear local */
      this.selectedFunction = "";
      this.rci[0] = State.filters.rciRange[0];
      this.rci[1] = State.filters.rciRange[1];
      this.ewg[0] = State.filters.ewgRange[0];
      this.ewg[1] = State.filters.ewgRange[1];

      /*State.filters.ecolabels.map(e => {
        if (this.$refs[e.id]) {
          this.$refs[e.id][0].uncheck();
        }
      });*/
      this.checkboxValues.fill(false);

      this.$emit("change", State.filterValues);
      this.isDirty = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filter-container {
  width: 350px;
  min-width: 350px;
  margin-right: 20px;
  padding: 20px;
  border-right: 1px solid #eeeeee;
  margin-right: 20px;
  background-color: #f5f5f5;
}

.field-container {
  margin-bottom: 20px;
}

.field-container.top-margin {
  margin-top: 40px;
}

.small {
  font-size: 12px;
}

.hide-on-desktop {
  display: none;
}

@media all and (max-width:800px) {
  .filter-container {
    box-sizing: border-box;
    display: none;
    margin-right: 0;
    width: 100%;
    min-width: unset;
  }

  .filter-container.open {
    display: block;
  }

  .hide-on-desktop {
    display: block;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
  }
}
</style>